import { render, staticRenderFns } from "./admin-stand-by.vue?vue&type=template&id=cb0615ea"
import script from "./admin-stand-by.vue?vue&type=script&lang=js"
export * from "./admin-stand-by.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports